import { render } from "./AddQcm.vue?vue&type=template&id=4b996281"
import script from "./AddQcm.vue?vue&type=script&lang=js"
export * from "./AddQcm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__